import { render, staticRenderFns } from "./userdetail.vue?vue&type=template&id=4c9593ed&scoped=true&"
import script from "./userdetail.vue?vue&type=script&lang=js&"
export * from "./userdetail.vue?vue&type=script&lang=js&"
import style0 from "./userdetail.vue?vue&type=style&index=0&id=4c9593ed&prod&scoped=true&lang=css&"
import style1 from "./userdetail.vue?vue&type=style&index=1&id=4c9593ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9593ed",
  null
  
)

export default component.exports